import React, { useState, useEffect } from "react";
import { Box } from "@mui/material";
import { keyframes } from "@emotion/react";
import PropTypes from "prop-types";

const wavy = keyframes`
  0%, 60%, 100% { transform: translateY(0); }
  30% { transform: translateY(-5px); }
`;

export default function RotatingTextLoader({ messages, interval = 5000 }) {
  const [messageIndex, setMessageIndex] = useState(0);

  useEffect(() => {
    // Reset if messages prop changes entirely
    setMessageIndex(0);
  }, [messages]);

  useEffect(() => {
    if (messages && messages.length > 0 && messageIndex < messages.length - 1) {
      const timer = setTimeout(() => {
        setMessageIndex((prev) => prev + 1);
      }, interval);
      return () => clearTimeout(timer);
    }
  }, [messageIndex, messages, interval]);

  if (!messages || messages.length === 0) return null;

  return (
    <div className="text-sm font-plusjakarta font-medium inline-block text-gray-500 italic transition-all duration-300">
      <span className="inline">{messages[messageIndex]}</span>
      <Box display="inline-flex" alignItems="center" ml={0.5}>
        {[0, 1, 2].map((i) => (
          <Box
            key={i}
            component="span"
            sx={{
              display: "inline-block",
              fontWeight: "bold",
              fontSize: 16,
              animation: `${wavy} 1.2s infinite`,
              animationDelay: `${i * 0.15}s`,
              mx: 0,
            }}
          >
            .
          </Box>
        ))}
      </Box>
    </div>
  );
}

RotatingTextLoader.propTypes = {
  messages: PropTypes.arrayOf(PropTypes.string).isRequired,
  interval: PropTypes.number
};
